import { useEffect, useRef, useState } from 'react';

/** Simple mm:ss resend-cooldown timer shared by the OTP/2FA screens. */
export function useResendCooldown(seconds = 60) {
  const [remaining, setRemaining] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => () => clearInterval(intervalRef.current), []);

  const start = () => {
    clearInterval(intervalRef.current);
    setRemaining(seconds);
    intervalRef.current = setInterval(() => {
      setRemaining((r) => {
        if (r <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return r - 1;
      });
    }, 1000);
  };

  return { remaining, start, canResend: remaining === 0 };
}
